import {useMutation, useQueryClient} from 'react-query'
import {BASE_URL} from '../../config'
import {IArticleAddForm, initArticleAddFormValues} from '../core/_model'
import axios from 'axios'
import toast from 'react-hot-toast'
import {handleApiError, handleAxiosError} from '../../../utils/helperFunction/_helper'
import {useNavigate, useParams, useSearchParams} from 'react-router-dom'
import {useFormik} from 'formik'
import JoditTextEditor from '../../../utils/components/rich-text-editor/JoditTextEditor'
import OptimizedSelectBox from '../../../utils/components/OptimizedSelectBox'
import useCategoriesOptions from '../../../hooks/useCategoriesOptions'
import {useEffect} from 'react'
import RichTextEditor from '../../../utils/components/rich-text-editor/RichTextEditor'

const CREATE_ARTICLE_URL = `${BASE_URL}/api/protect/createKnowledge`
const GET_ARTICLE_LIST_BY_ID = `${BASE_URL}/api/protect/getKnoledgeById`
const UPDATE_ARTICLE_URL = `${BASE_URL}/api/protect/updateKnowledge`

const ArticleForm = () => {
  const {type} = useParams()
  const [searchParams] = useSearchParams()
  const id = searchParams.get('id')
  const {categoriesOptions} = useCategoriesOptions()
  const navigate = useNavigate()
  const queryClient = useQueryClient()

  const {mutateAsync: addArticle} = useMutation({
    mutationKey: ['article'],
    mutationFn: async (sendValues: Partial<IArticleAddForm>) => {
      toast.loading('Processing..')
      if (id) {
        const values = {
          id,
          title: sendValues.title,
          description: sendValues.description,
          category: sendValues.category,
        }
        const response = await axios.put(UPDATE_ARTICLE_URL, values)
        console.log(response)
      } else {
        const values = {
          title: sendValues.title,
          description: sendValues.description,
          category: sendValues.category,
        }
        const response = await axios.post(CREATE_ARTICLE_URL, values)
        console.log(response)
      }
    },
    onSuccess: () => {
      toast.dismiss()
      toast.success('Successfull, and Fetching data..')
      queryClient.invalidateQueries(['category'])
      resetForm()
      navigate('/knowledgebase/article')
    },
    onError: (error: Error) => {
      toast.dismiss()
      const message = handleApiError(error)
      console.log(error)
      toast.error(message || 'Unexpected error occured, Please try again.')
    },
  })

  const formik = useFormik({
    initialValues: initArticleAddFormValues,
    onSubmit: async (values) => {
      try {
        console.log(values)
        await addArticle(values)
      } catch (error) {
        console.log(error)
      }
    },
  })

  const onSelectCategory = (id: number) => formik.setFieldValue('category', id)

  const resetForm = () => {
    formik.resetForm()
  }

  const onContentChange = (content: string) => {
    formik.setFieldValue('description', content)
  }

  const getArticleBydId = async () => {
    try {
      const response = await axios.get(`${GET_ARTICLE_LIST_BY_ID}/${id}`)
      console.log(response)

      if (response.status === 200) {
        toast.dismiss()
        const data = await response.data
        formik.setValues({
          title: data.title,
          description: data.description,
          category: data.category_id,
          categoryName: data.category_name,
        })
      }
    } catch (error) {
      toast.dismiss()
      console.log(error)
      const message = handleAxiosError(error)
      toast.error(message)
    }
  }

  useEffect(() => {
    if (type && id) {
      toast.loading('Processing..')
      getArticleBydId()
    }
  }, [type, id])

  return (
    <div>
      <h3>{type === 'create' ? 'Create' : 'Update'} Article</h3>

      <div className='card mt-8'>
        <div className='card-body'>
          <form onSubmit={formik.handleSubmit}>
            <div className='row mb-4'>
              <label className='col-lg-3 col-form-label fs-6'>
                <span className=''>Category</span>
              </label>

              <div className='col-lg-9 fv-row'>
                <OptimizedSelectBox
                  formik={formik}
                  fieldValue='categoryName'
                  options={categoriesOptions}
                  placeholder='Select category'
                  setSelect={onSelectCategory}
                />
              </div>
            </div>

            <div className='row mb-4'>
              <label className='col-lg-3 col-form-label fs-6'>
                <span className=''>Title</span>
              </label>

              <div className='col-lg-9 fv-row'>
                <input
                  placeholder='Enter title'
                  {...formik.getFieldProps('title')}
                  type='text'
                  name='title'
                  className='form-control form-control custom-input mb-3 mb-lg-0'
                  autoComplete='off'
                />
              </div>
            </div>

            <div className='row mb-10'>
              <label className='col-lg-3 col-form-label fs-6'>Description</label>
              <div className='col-lg-9 fv-row-3 mt-2'>
                <RichTextEditor
                  content={formik.values.description}
                  onContentChange={onContentChange}
                />
                {/* <JoditTextEditor
                  content={formik.values.description}
                  onChangeContent={onContentChange}
                /> */}
                {/* <textarea
                    {...formik.getFieldProps('description')}
                    name='description'
                    placeholder='Enter Description..'
                    className='form-control form-control-lg form-control custom-input'
                    rows={5}
                    style={{resize: 'vertical', fontSize: '1.0rem'}}
                    required
                  ></textarea> */}
              </div>
            </div>

            <div className='d-flex justify-content-end'>
              <button type='button' className='btn btn-light me-4' onClick={resetForm}>
                Reset
              </button>
              <button type='submit' className='btn btn-primary'>
                {type === 'create' ? 'Add' : 'Edit'} Article
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  )
}

export default ArticleForm
